/**
 * Mirrors WebApi Models.Common.NewViewerBackend.ProjectStatusEnum (serialized as string).
 *
 * The three Pending* values are the sub-stages of "הפרויקט ממתין לאישור" in the designer's
 * status timeline; the admin "ממתין לאישור" tab aggregates all three.
 */
export enum ProjectStatus {
  /** בדיקה ראשונית — every new project starts here. */
  PendingInitialReview = 'PendingInitialReview',
  /** בדיקה בוועדת רווחה. */
  PendingWelfareCommittee = 'PendingWelfareCommittee',
  /** בדיקה בוועדת התמיכות של מרכז הצדקה. */
  PendingSupportsCommittee = 'PendingSupportsCommittee',
  Approved = 'Approved',
  Rejected = 'Rejected',
  /**
   * ממתין לתשובת רכז (SPR-10302): the office asked a question (the status comment). Deliberately
   * NOT in pendingProjectStatuses: the coordinator must see that the project waits for THEM, not
   * the generic "ממתין לאישור".
   */
  PendingCoordinatorResponse = 'PendingCoordinatorResponse',
  /** הפניה למחלקה המשפטית (SPR-10302) — a review stage; mails the legal department. */
  PendingLegalReview = 'PendingLegalReview',
}

/** The statuses the admin "ממתין לאישור" tab covers. */
export const pendingProjectStatuses: ProjectStatus[] = [
  ProjectStatus.PendingInitialReview,
  ProjectStatus.PendingWelfareCommittee,
  ProjectStatus.PendingSupportsCommittee,
  // A review stage like the committees: the coordinator sees "ממתין לאישור".
  ProjectStatus.PendingLegalReview,
];

export const isPendingProjectStatus = (status: ProjectStatus): boolean =>
  pendingProjectStatuses.includes(status);

/** Mirrors WebApi Models.Common.NewViewerBackend.SupplierApprovalStatusEnum. */
export enum SupplierApprovalStatus {
  PendingApproval = 'PendingApproval',
  Approved = 'Approved',
  Rejected = 'Rejected',
}

/** תדירות — mirrors ProjectExpenseFrequencyEnum. */
export enum ProjectExpenseFrequency {
  /** חודשי */
  Monthly = 'Monthly',
  /** מצטבר */
  Cumulative = 'Cumulative',
}
